import { Dispatch, SetStateAction } from 'react';
import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { UserKeys } from '../../../api/users-api';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface ContactSyncGridToolbarProps {
  directoryRoles: string[];
  setOpenCreateContactSync: Dispatch<SetStateAction<boolean>>;
  mutate: UseMutateFunction<void, unknown, void, unknown>;
  isRunningAll: boolean;
}

export default function ContactSyncGridToolbar({
  directoryRoles,
  setOpenCreateContactSync,
  mutate,
  isRunningAll,
}: ContactSyncGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          onClick={() => setOpenCreateContactSync(true)}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.AddContactSync.value
            )
          }
          label="Add Contact Sync"
          tooltipLabel={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.AddContactSync.value
            )
              ? `You are missing the ${DirectoryRoles.AddContactSync.name} permission to perform this action.`
              : ''
          }
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="complete"
            onClick={() => mutate()}
            isLoading={isRunningAll}
            tooltipLabel="Run all"
          />
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              void queryClient.invalidateQueries({
                queryKey: [UserKeys.ContactSyncs],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="contactSyncsGridStates"
            module={ModuleList.modules.directory.name}
            section={ModuleList.modules.directory.sections.contactSync}
          />
        </>
      }
    />
  );
}
